module.exports = __webpack_public_path__ + "images/01d0537e8b62fc909acc00b778ecb5e2.jpg";